import { updateBODStep } from 'actions/clz/0bod';
import cls from 'classnames';
import Button from 'components/common/Button';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { noop } from 'lodash';
import { func } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import React from 'react';
import { sendGAEvent } from 'utils/ga';
import history from '../../../../history';
import { STEPS, STEP_NAME } from '../constant';
import s from './style.css';

class DuplicatedOutTime extends React.Component {
  static propTypes = {
    goToPage: func,
  };

  static defaultProps = {
    goToPage: noop,
  };

  componentDidMount() {
    sendGAEvent(
      'Visit_Page',
      'Dedupe_OO_Work_Hour_Page',
      'ACL_0BOD_Dedupe_OO_Work_Hour',
    );
  }

  handleClick = () => {
    sendGAEvent('Tap_Back', 'Back_Button', 'ACL_0BOD_Dedupe_OO_Work_Hour');
    this.props.goToPage(STEPS.START_LOAN);
    history.push(`/${STEP_NAME[STEPS.START_LOAN]}`);
  };

  render() {
    return (
      <div className={s.container}>
        <div className={s.logoWrapper}>
          <img
            src="./../images/song-vui-3x.png"
            className={s.logo}
            alt="Sống vui cùng HomeCredit"
          />
        </div>
        <div className={s.imageWrapper}>
          <img
            className={s.image}
            src="./../images/close.png"
            alt="Ngoài giờ làm việc"
          />
        </div>
        <div className={s.content}>
          <p className={cls(s.name, s.noSpace)}>
            Ngoài khung giờ xét duyệt hồ sơ
          </p>
          <p className={s.waitingConfirm}>
            Vui lòng đăng ký lại vào ngày mai trong giờ hành chính.
          </p>
        </div>
        <div className={s.btnWrapper}>
          <Button
            type="submit"
            onClick={this.handleClick}
            className={s.btnGoBack}
          >
            TRỞ VỀ TRANG CHÍNH
          </Button>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  goToPage: step => {
    dispatch(updateBODStep(step));
  },
});
const enhance = compose(
  connect(
    null,
    mapDispatchToProps,
  ),
  withStyles(s),
);

export default enhance(DuplicatedOutTime);
